// extracted by mini-css-extract-plugin
export default {"row":"styles_row__ACwCm","maintitle":"styles_maintitle__0YyLW","searchCol":"styles_searchCol__scB8b"};